import React from 'react'
import styles from './styles.css'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import AccountIcon from 'react-icons/lib/md/account-circle'
import LogoutIcon from 'react-icons/lib/md/exit-to-app'
import TiGroupOutline from 'react-icons/lib/ti/group-outline'
import autobind from 'autobind-decorator'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import { logout } from 'meteor-apollo-accounts'
import { withApollo } from 'react-apollo'
import sleep from 'orionsoft-parts/lib/helpers/sleep'
import PropTypes from 'prop-types'
import Signature from './Signature'
import withOrganization from 'App/Decorators/withOrganization'
import { Link, withRouter } from 'react-router'
import { MdRotate90DegreesCcw } from 'react-icons/lib/md'
import TiPlusOutline from 'react-icons/lib/ti/plus-outline'
import Sidebar from 'App/Pages/Layout/Sidebar'
import { Mobile } from 'App/components/Devices'
import MdVpnKey from 'react-icons/lib/md/vpn-key'
import includes from 'lodash/includes'
import get from 'lodash/get'

@withRouter
@withOrganization
@withGraphQL(
  gql`
    query getMe {
      me {
        _id
        email
        profile {
          name
        }
        roles
        ...userSignature
      }
    }
    ${Signature.fragment}
  `,
  {
    loading: null
  }
)
@withGraphQL(gql`
  query organizationUser {
    organizationUser {
      _id
      name
      slug
      archived
    }
  }
`)
@withApollo
export default class User extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    me: PropTypes.func,
    client: PropTypes.object,
    organization: PropTypes.object,
    organizationUser: PropTypes.array
  }

  state = { open: false }

  componentDidMount() {
    window.addEventListener('mouseup', this.closeMenu, false)
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.closeMenu)
  }

  @autobind
  async closeMenu(event) {
    if (!this.state.open) return true
    await sleep(100)
    this.setState({ open: false })
  }

  @autobind
  toggleMenu() {
    this.setState({ open: !this.state.open })
  }

  @autobind
  async logout(event) {
    try {
      await logout(this.props.client)
      await this.props.client.resetStore()
      this.props.router.push('/login')
    } catch (error) {
      console.log('Error:', error)
    }
  }

  renderOrganization() {
    if (!this.props.organization || !this.props.organization._id) {
      const myOrganizations = this.props.organizationUser || []
      return myOrganizations.map((myOrg, index) => {
        return (
          <a
            onClick={() =>
              (window.location.href = `https://${myOrg.slug}.tufirma.digital`)
            }
            key={index}
            className={styles.menuLink}
          >
            <TiGroupOutline size={20} />
            <span>{myOrg.name}</span>
          </a>
        )
      })
    } else {
      return (
        <a
          onClick={() => (window.location.href = 'https://app.tufirma.digital')}
          className={styles.menuLink}
        >
          <MdRotate90DegreesCcw size={20} />
          <span>
            tu<b>firma</b>.digital
          </span>
        </a>
      )
    }
  }

  renderCreateOrganization() {
    if (!includes(get(this.props, 'me.roles', []), 'admin')) return
    return (
      <a
        onClick={() => (window.location.href = `/createorganization`)}
        className={styles.menuLink}
      >
        <TiPlusOutline size={20} />
        <span>{'Crear Organización'}</span>
      </a>
    )
  }

  renderAdmin() {
    if (!includes(get(this.props, 'me.roles', []), 'admin')) return
    return (
      <Link to={`/Admin`} className={styles.menuLink}>
        <MdVpnKey size={20} />
        <span>Administrador</span>
      </Link>
    )
  }

  renderMenu() {
    if (!this.state.open) return
    return (
      <div className={styles.menu} key="menu">
        <div className={styles.account}>
          <div className={styles.name}>
            {this.props.me.profile && this.props.me.profile.name}
          </div>
          <div className={styles.email}>{this.props.me.email}</div>
        </div>
        <Signature user={this.props.me} />
        <Mobile>
          <Sidebar />
        </Mobile>
        {this.renderOrganization()}
        {this.renderCreateOrganization()}
        {this.renderAdmin()}
        <a onClick={this.logout} className={styles.menuLink}>
          <LogoutIcon size={20} />
          <span>Sign Out</span>
        </a>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <AccountIcon
          className={styles.icon}
          size={25}
          onClick={this.toggleMenu}
        />
        <ReactCSSTransitionGroup
          transitionName="user-menu"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {this.renderMenu()}
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/Navbar/User/index.js